import BaseEvaluator from './BaseEvaluator';

export default class MinEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'min';
  }

  validate() {
    this.isValid = !Number.isNaN(parseInt(`${this.mutator[0]}`, 10));
    if (this.isValid) {
      this.mutator[0] = parseInt(`${this.mutator[0]}`, 10);
      this.isValid = this.value.length >= this.mutator[0];
    }
    return this.isValid;
  }
}
